// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__34YCX","container":"styles_container__10EMG","title":"styles_title__C-E8x","wrapper":"styles_wrapper__1NXKY","answer":"styles_answer__1eTmq"};